/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PrefixContext = /*#__PURE__*/React__default["default"].createContext('cds');
function usePrefix() {
  return React__default["default"].useContext(PrefixContext);
}

exports.PrefixContext = PrefixContext;
exports.usePrefix = usePrefix;
